/* --- Dependencies --- */
import React, { Component } from "react";
import { Link } from "react-router";
import styles from "./AppFooter.module.less";
import { FormattedMessage } from "react-intl";
import moment from "moment";
import getLocaleSwitcherTargets from "./getLocaleSwitcherTargets";
export default class AppFooter extends Component {
    /* --- React Lifecycle Methods --- */
    /**
     * React lifecycle method
     * @method render
     * @private
     * @returns {HTMLElement} Component element
     */
    render() {
        const { props } = this;
        return (<footer role="contentinfo" className="footer">
				<div className="footer-wrapper">
					<div className="footer-wrapper-content">
						{props.loggedIn && (<p className={styles.miniMiranda}>
								<FormattedMessage id="footer.miniMiranda" defaultMessage={"This company is a debt collector attempting to collect a debt and any information obtained "
            + "will be used for that purpose."}/>
							</p>)}
						<div className="footerGroup">
							<span className="footerGroup-item">&copy; DCM Services {moment().toDate().getFullYear()}</span>
							<span className="footerGroup-item">
								<FormattedMessage id="footer.allRightsReserved" defaultMessage="All rights reserved"/>
							</span>
						</div>
						<ul className="footerGroup">
							<li className="footerGroup-item">
								<a className="footerGroup-item-link" rel="noopener noreferrer" target="_blank" href="https://www.dcmservices.com/privacy-policy">
									<FormattedMessage id="footer.privacy" defaultMessage="Privacy"/>
								</a>
							</li>
							<li className="footerGroup-item">
								<Link className="footerGroup-item-link" to="/public/legal">
									<FormattedMessage id="footer.legal" defaultMessage="Legal"/>
								</Link>
							</li>
							<li className="footerGroup-item">
								<a className="footerGroup-item-link" rel="noopener noreferrer" target="_blank" href="https://www.dcmservices.com/terms-of-use">
									<FormattedMessage id="footer.terms" defaultMessage="Terms"/>
								</a>
							</li>
							<li className="footerGroup-item">
								<Link className="footerGroup-item-link" to="/public/accessibility">
									<FormattedMessage id="footer.accessibility" defaultMessage="Accessibility"/>
								</Link>
							</li>
							<li className="footerGroup-item">
								<a className="footerGroup-item-link" rel="noopener noreferrer" target="_blank" href="https://www.dcmservices.com/ca-privacy-rights">
									<FormattedMessage id="caprivacy.header" defaultMessage="CA Privacy Rights"/>
								</a>
							</li>
							{getLocaleSwitcherTargets(props.locale).map(({ locale, label }) => (<li key={locale} className="footerGroup-item" lang={locale}>
									<button type="button" className="footerGroup-item-link" onClick={() => props.selectLocale(locale)}>
										{label}
									</button>
								</li>))}
						</ul>
					</div>
				</div>
			</footer>);
    }
}



// WEBPACK FOOTER //
// ./src/assets/scripts/components/presentational/AppFooter/AppFooter.tsx